import { render } from "./ManualResearchBar.vue?vue&type=template&id=672fdf72&scoped=true"
import script from "./ManualResearchBar.vue?vue&type=script&lang=js"
export * from "./ManualResearchBar.vue?vue&type=script&lang=js"

import "./ManualResearchBar.vue?vue&type=style&index=0&id=672fdf72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672fdf72"]])

export default __exports__